"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fromNullableOrDefault = exports.isUndefined = exports.isNotUndefined = exports.isNull = exports.isNotNull = exports.isNotNil = exports.isNil = void 0;

var isNil = function isNil(value) {
  return value === null || value === undefined;
};

exports.isNil = isNil;

var isNotNil = function isNotNil(value) {
  return value !== null && value !== undefined;
};

exports.isNotNil = isNotNil;

var isNull = function isNull(x) {
  return x === null;
};

exports.isNull = isNull;

var isNotNull = function isNotNull(x) {
  return x !== null;
};

exports.isNotNull = isNotNull;

var isUndefined = function isUndefined(x) {
  return x === undefined;
};

exports.isUndefined = isUndefined;

var isNotUndefined = function isNotUndefined(x) {
  return x !== undefined;
};

exports.isNotUndefined = isNotUndefined;

var fromNullableOrDefault = function fromNullableOrDefault(defaultValue) {
  return function (nullable) {
    if (nullable === null) return defaultValue;
    return nullable;
  };
};

exports.fromNullableOrDefault = fromNullableOrDefault;
//# sourceMappingURL=index.js.map